<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_course.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_price.css" type="text/css" media="all" scoped></style>
<template>
  <div class="container" id="step02">
    <div class="contents">
			<h2>健診予約</h2>
      <section class="flow">
        <h3>予約申し込みの流れ</h3>
        <ol>
          <li>コース選択</li>
          <li>オプション選択</li>
          <li>受診日時選択</li>
          <li>予約情報入力</li>
          <li>予約情報確認</li>
          <li>予約確定</li>
        </ol>
      </section>
      <!-- ▽  -->
      <section id="mainContents">
        <!-- 現在の料金（レイアウトは現状ただ並べているだけです。自由に変えてください） -->
        <!-- spanには金額を「51700」⇒「51,700」にするスタイルを入れて欲しいです -->
        <!-- ▽  -->
        <section class="inputArea">
          <h3>【コース詳細・オプション選択】</h3>
          <p>ご希望のオプションを選択してください。</p>
          <p>希望されるオプションがない方はそのまま日にちの選択へお進みください。</p>
          <article class="course">
            <h4><span>希望コース</span>{{inputForm.course.ksnm}}</h4>
            <dl class="item">
              <dt>検査項目</dt>
              <dd>
                <ul>
                <li v-for="inspection in inputForm.course.listInspection" v-bind:key="inspection.kmnm" v-bind:class="getBackendColorInspectionJskb(inspection.jskb)">{{inspection.kmnm}}</li>
                </ul>
              </dd>
            </dl>
            <p class="time"><span>所要時間</span>{{inputForm.course.time}}</p>

          <div class="sticky">
            <!-- ▽ 料金計算 -->
            <div class="price" v-if="!getNoOptionFlag">
              <h4>選択内容</h4>
              <p class="base">{{inputForm.course.ksnm}}
                <em>
                  <template v-if="inputForm.kshj=='1'">
                  {{inputForm.course.gkgk | moneyDelimiter}}
                    <span v-if="inputForm.taxk=='1'">（税抜）</span>
                    <span v-else>（税込）</span>
                  </template>
                </em>
              </p>
              <ul>
                <li v-for="(option,index) in getOptionKoumokuGkGk">
                  {{getOptionKoumokuName[index]}}
                  <em>
                    <template v-if="inputForm.kshj=='1'">
                      {{option | moneyDelimiter}}
                      <span v-if="inputForm.taxk=='1'">（税抜）</span>
                      <span v-else>（税込）</span>
                    </template>
                  </em>
                </li>
              </ul>
              <p class="total">合計金額
                <b>
                  <template v-if="inputForm.kshj=='1'">
                    {{getSumKngk | moneyDelimiter}}
                      <span v-if="inputForm.taxk=='1'">（税抜）</span>
                      <span v-else>（税込）</span>
                  </template>
                </b>
              </p>
              <div class="btnLst"><button class="nextBtn" v-on:click="onNext">日にちの選択へ</button></div>
            </div>
          </div>

            <div class="option">
              <h5>オプション一覧</h5>
              <div v-if="getNoOptionFlag" class="noOption">
                <p>選択いただいたコースにはオプションがありません。</p>
                <p>「日にちの選択へ」ボタンを押下し、受診日時の選択画面へお進み下さい。</p>
              </div>
              <dl v-for="(option,index0) in inputForm.listOpClass" v-bind:key="option.opbr">
                <!-- リセットボタンは非表示となったが戻す可能性が高いのでコード事態は消さずにコメントアウトしておく -->
                <!-- なお、onClearChoiceメソッドはコース選択からの遷移時にも使用されているのでそのままにしている -->
                <dt>{{option.brnm}}<!--<button class="cancelBtn" v-on:click="onClearChoice(index0)">リセット</button>--></dt>
                <dd class="price"><p>{{option.mem1}}</p>
                <!-- 択一式（ラジオ） -->
                  <ul v-if="option.trkb == '1'">
                    <li v-for="opItem in option.listOpItems" v-bind:key="opItem.opcd">
                      <label class="radio"><input type="radio" v-bind:value="opItem.opcd" v-model="inputForm.choiceOpbr[index0].opcd"><span>{{opItem.opnm}}</span><em>{{opItem.gkgk | moneyDelimiter}}<span>（税込）</span></em></label>
                    </li>
                  </ul>
                  <!-- 選択式（チェックボックス） -->
                  <ul class="checkLst" v-else>
                    <li v-for="opItem in option.listOpItems" v-bind:key="opItem.opcd">
                      <label class="checkbox"><input type="checkbox" v-bind:value="opItem.opcd" v-model="inputForm.choiceOpbr[index0].opcd"><span>{{opItem.opnm}}</span><em>{{opItem.gkgk | moneyDelimiter}}<span>（税込）</span></em></label>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
          </article>
        </section>
        <!-- △  END -->
        <div class="btnLst">
          <button class="nextBtn" v-on:click="onNext" v-if="getNoOptionFlag">日にちの選択へ</button>
        	<button class="backBtn" v-on:click="onBack">戻る</button>
        </div>
      </section>
      <!-- △ mainContents END -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
        <dt slot="modal-header">入力エラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonSelectOption } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonSelectOption',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // データ
    data() {
      return {

        inputForm: {
          // 消費税区分
          // 1: 外税 税抜
          // 2: 内税 税込
          taxk: '1',

          // 金額表示
          // 0:非表示 1:表示
          kshj: '1',

          // 選択したコース
          // ksnm コース名称
          // time 所要時間
          // kngk 本体価格（未使用）
          // gkgk 消費税考慮済み金額
          // listInspection 検査項目リスト
          //  kmnm 検査項目名称
          //  jskb 受診区分(1:全員 2:一部)
          course: {
            ksnm: '',
            time: '',
            kngk: '',
            gkgk: '',
            listInspection: []
          },
          // オプション分類リスト
          // opbr オプション分類コード
          // brnm オプション分類名称
          // mem1 オプション分類説明
          // trkb オプション分類毎の登録方法（1:択一式 2:選択式）
          // listOpItems
          //  opcd オプション項目コード
          //  jkcd 条件コード
          //  opnm オプション項目名称
          //  dffg オプション項目 初期チェック（0:false、1:true）選択式の場合　1つのみチェック可能
          //  kngk オプション項目 金額
          //  gkgk オプション項目 合計金額
          listOpClass: [],
          // :TODO 初期表示時のエラー対応の為、連想配列は作成しておく
          // もっといい方法あれば変える
          choiceOpbr: [
            {
              opcd:''
            },
          ],
        },
        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // 算出プロパティ
    computed: {

      // 選択したオプション項目の名称
      getOptionKoumokuName: function () {
        return this.createOptionKoumokuOpnmArray()
      },
      // 選択したオプションの金額（消費税考慮済み金額）
      getOptionKoumokuGkGk: function () {
        return this.createOptionKoumokuGkGkArray()
      },
      // 選択したコース及びオプション項目の合計金額
      // （消費税考慮済み金額）
      getSumKngk: function () {

        // 合計金額
        var resultSumKngk = 0
        // 選択したオプションの金額
        var opGkgkList = this.createOptionKoumokuGkGkArray()

        // 選択したコースの金額を加える
        resultSumKngk += this.inputForm.course.gkgk
        // 選択したオプションの金額を加える
        opGkgkList.forEach((opGkgk) => { resultSumKngk += opGkgk })

        return resultSumKngk
      },
      // 選択したオプションリスト
      // オプションリストが0件の時trueを返す
      getNoOptionFlag: function () {
        return (this.inputForm.listOpClass.length == 0)
      }
    },
    // フィルター
    filters: {
      // 金額表示用三桁ごとにカンマをつける
      moneyDelimiter: function(value) {

        if(value == null) {
          return ''
        }
        
        return value.toLocaleString()
      }
    },
    // ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonSelectOption::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonSelectOption::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('CommonSelectOption::firstDisplay Start')

        // 金額表示、消費税区分、選択したコース、オプション一覧を取得
        CommonSelectOption.FirstDisplay({
          ircd: this.$store.state.auth.ircd,
          jgcd: this.$store.state.commonUserInfo.newHealthInsurance.jgcd,
          nend: this.$store.state.commonUserInfo.newHealthInsurance.nend,
          hfkb: this.$store.state.commonUserInfo.newHealthInsurance.hfkb,
          sex: this.$store.state.commonUserInfo.newHealthInsurance.sex,
          age: this.$store.state.commonUserInfo.newHealthInsurance.age,
          kscd: this.$store.state.commonUserInfo.selectCourse.kscd,
          jkcd: this.$store.state.commonUserInfo.selectCourse.jkcd
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.inputForm.kshj = responce.data.kshj
            this.inputForm.taxk = responce.data.taxk
            this.inputForm.course = responce.data.course
            this.inputForm.listOpClass = responce.data.listOpClass

            this.inputForm.choiceOpbr = []
            for (var i = 0; i < this.inputForm.listOpClass.length;i++) {
              if('1' == this.inputForm.listOpClass.trkb) {
                this.inputForm.choiceOpbr.push({ opcd:'' })
              } else {
                this.inputForm.choiceOpbr.push({ opcd:[] })
              }
            }

            // カレンダー選択画面を通ったかどうか
            var tempCalenderIsUse = this.$store.state.commonUserInfo.selectCalender.isUse
            var tempStoreOpBrs = this.$store.state.commonUserInfo.selectOption.opbr
            var tempStoreOpcds = this.$store.state.commonUserInfo.selectOption.opcd

            // カレンダーの戻り遷移かつオプションの選択があった場合のみ
            // 値をストアから引き継ぐ
            if(tempCalenderIsUse && tempStoreOpBrs.length > 0
              && tempStoreOpcds.length > 0) {

              // どの分類の選択か
              var indexChoiceOpbr = 0

              for(var i=0;i<this.inputForm.listOpClass.length;i++) {
                // どの分類の選択か
                indexChoiceOpbr = i
                // 分類コード
                var tempOpbr = this.inputForm.listOpClass[indexChoiceOpbr].opbr
                // 登録方法
                // 1:択一式 ラジオ 文字列扱い
                // 2:選択式 チェックボックス 文字列配列
                var tempTrkb = this.inputForm.listOpClass[indexChoiceOpbr].trkb

                for(var j=0;j<tempStoreOpBrs.length;j++) {
                  if(tempOpbr == tempStoreOpBrs[j]) {
                    if('1' == tempTrkb) {
                      // 1:択一式 ラジオ 文字列扱い
                      this.inputForm.choiceOpbr[indexChoiceOpbr].opcd = tempStoreOpcds[j]
                    }
                    else if('2' == tempTrkb){
                      // 2:選択式 チェックボックス 文字列配列
                      this.inputForm.choiceOpbr[indexChoiceOpbr].opcd.push(tempStoreOpcds[j])
                    }
                  }
                }
              }
            } else {
              // 戻り遷移以外の遷移時（コース選択からの遷移時）
              for(var i=0;i<this.inputForm.listOpClass.length;i++) {
                this.onClearChoice(i)
              }
            }

            // ストアのカレンダー画面を通ったかどうかフラグをfalseにする
            this.$store.commit(
              types.COMMON_SELECTOPTION_FIRSTDISPLAY)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonSelectOption::firstDisplay End')
	      })

      },
      // 表示系--------------------------------------------------E
      // イベント系--------------------------------------------------S
      onNext: function () {
        UtilityConsoleLog.consoleLog('CommonSelectOption::onNext Start')

        var opbrArray = []
        var opcdArray = []
        
        for (var i = 0; i < this.inputForm.choiceOpbr.length; i++) {
          if (!Array.isArray(this.inputForm.choiceOpbr[i].opcd)) {
              if(this.inputForm.choiceOpbr[i].opcd != '') {
                opbrArray.push(this.inputForm.listOpClass[i].opbr)
                opcdArray.push(this.inputForm.choiceOpbr[i].opcd)
              }
          } else {

            var strOpcds = this.inputForm.choiceOpbr[i].opcd.slice()
            strOpcds = strOpcds.sort()

            strOpcds.forEach(
              (opcdItem) => {
                opbrArray.push(this.inputForm.listOpClass[i].opbr)
                opcdArray.push(opcdItem)
              })
          }
        }

        var jkcdArray = []
        for(var i=0;i<opcdArray.length;i++) {
          jkcdArray.push(
            this.getOptionJkcd(opbrArray[i],opcdArray[i])
          )
        }

        // ストアに保存
        this.$store.commit(
          types.COMMON_SELECTOPTION,
          {
            opbr: opbrArray,
            opcd: opcdArray,
            jkcd: jkcdArray
          }
        )

        // カレンダー選択画面へ遷移
        this.$router.push("/CommonSelectCalender")

        UtilityConsoleLog.consoleLog('CommonSelectOption::onNext End')
      },
      // 戻るボタン押下時
      onBack: function () {
        
        UtilityConsoleLog.consoleLog('CommonSelectOption::onBack Start')

        // ストアの値をリセット
        this.$store.commit(
          types.COMMON_SELECTOPTION_BACK)

        // コース選択画面へ遷移
        this.$router.push("/CommonSelectCourse")

        UtilityConsoleLog.consoleLog('CommonSelectOption::onBack End')
      },
      // 各オプション分類の選択値をリセットする
      // オプション分類毎の登録方法
      // 1: 択一式の場合、初期値(dffg)をinputForm.choiceOpcr[in_index].opcdに代入
      //             （inputForm.choiceOpcr[in_index].opcdはこの時文字列変数扱い）
      // 2: 選択式の場合、[]をinputForm.choiceOpcr[in_index].opcdに代入
      //             （inputForm.choiceOpcr[in_index].opcdはこの時文字列配列変数扱い）
      onClearChoice: function (in_index) {

        UtilityConsoleLog.consoleLog('CommonSelectOption::onClearChoice Start')
        
        // オプション分類毎の登録方法（1:択一式 2:選択式）
        var tempTrkb = this.inputForm.listOpClass[in_index].trkb
        // オプション分類が択一式の場合の初期選択するオプション項目コード
        var tempOpcd = ''        
        
        var tempOpcdObj = this.inputForm.listOpClass[in_index].listOpItems.find((item) =>{
          return item.dffg == '1'
        })

        if(tempOpcdObj != null) {
          tempOpcd = tempOpcdObj.opcd
        }

        // オプション分類毎の登録方法によるopcdの取り扱い方によって
        // 各オプション分類の選択値をリセットする
        if('1' == tempTrkb) {
          this.inputForm.choiceOpbr[in_index].opcd = tempOpcd
        } else if('2' == tempTrkb){
          this.inputForm.choiceOpbr[in_index].opcd = []
        }

        UtilityConsoleLog.consoleLog('CommonSelectOption::onClearChoice End')
      },
      // イベント系--------------------------------------------------E
      // その他--------------------------------------------------S
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (errorMessages) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonSelectCourse::onSystemErrorModalClose End')
      },
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonSelectCourse::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
      // 検査項目の受診区分(1:全員 2:一部)によってCSSクラス名を返す
      // 1:全員の場合は背景色を黄色にする
      getBackendColorInspectionJskb: function (jskb) {

        var resultClassName = ''

        // 背景色を黄色にするクラス名を返す
        if ('1' == jskb) {
          resultClassName = 'courseListKensa1'
        } else {
          resultClassName = 'courseListKensa0'
        }

        return resultClassName;
      },
      createOptionKoumokuOpnmArray: function () {
      
        var resultOpnmList = []

        if (this.inputForm.listOpClass.length > 0) {
          for (var i = 0; i < this.inputForm.choiceOpbr.length; i++) {
            if (!Array.isArray(this.inputForm.choiceOpbr[i].opcd)) {

              var strOpcd = this.inputForm.choiceOpbr[i].opcd

              for (var j = 0; j < this.inputForm.listOpClass[i].listOpItems.length; j++) {
                if (strOpcd == this.inputForm.listOpClass[i].listOpItems[j].opcd) {
                  resultOpnmList.push(this.inputForm.listOpClass[i].listOpItems[j].opnm)
                }
              }

            } else {
              var strOpcds = this.inputForm.choiceOpbr[i].opcd.slice()
              strOpcds = strOpcds.sort()

              strOpcds.forEach(
                (opcd) => {
                  for (var j = 0; j < this.inputForm.listOpClass[i].listOpItems.length; j++) {
                    if (opcd == this.inputForm.listOpClass[i].listOpItems[j].opcd) {
                      resultOpnmList.push(this.inputForm.listOpClass[i].listOpItems[j].opnm)
                    }
                  }
                })
            }
          }
        }

        return resultOpnmList
      },
      createOptionKoumokuGkGkArray: function () {
      
        var resultGkgkList = []

        if (this.inputForm.listOpClass.length > 0) {
          for (var i = 0; i < this.inputForm.choiceOpbr.length; i++) {
            if (!Array.isArray(this.inputForm.choiceOpbr[i].opcd)) {

              var strOpcd = this.inputForm.choiceOpbr[i].opcd

              for (var j = 0; j < this.inputForm.listOpClass[i].listOpItems.length; j++) {
                if (strOpcd == this.inputForm.listOpClass[i].listOpItems[j].opcd) {
                  resultGkgkList.push(this.inputForm.listOpClass[i].listOpItems[j].gkgk)
                }
              }

            } else {
              var strOpcds = this.inputForm.choiceOpbr[i].opcd.slice()
              strOpcds = strOpcds.sort()

              strOpcds.forEach(
                (opcd) => {
                  for (var j = 0; j < this.inputForm.listOpClass[i].listOpItems.length; j++) {
                    if (opcd == this.inputForm.listOpClass[i].listOpItems[j].opcd) {
                      resultGkgkList.push(this.inputForm.listOpClass[i].listOpItems[j].gkgk)
                    }
                  }
                })
            }
          }
        }

        return resultGkgkList
      },
      // オプション条件コードを
      // オプション分類コードとオプション項目コードから取得
      getOptionJkcd: function(in_opbr,in_opcd){

	      var indexOpClass = 0
	      var resultJkcd = ''

        for(var i=0;this.inputForm.listOpClass.length;i++){
        	if(this.inputForm.listOpClass[i].opbr == in_opbr){
        		indexOpClass = i
        		break
        	}
        }

        for(var i=0;i<this.inputForm.listOpClass[indexOpClass].listOpItems.length;i++){
        	if(this.inputForm.listOpClass[indexOpClass].listOpItems[i].opcd == in_opcd){
        		resultJkcd = this.inputForm.listOpClass[indexOpClass].listOpItems[i].jkcd
        		break
        	}
        }

        return resultJkcd
      },
      // 択一式の選択値の初期値（項目コード）を取得する
      // 選択値のオプション分類もしくは初期値が未設定の場合は空文字を返す
      getOptionInitialize: function(in_opbr) {
      
      	var resultOpcd = ''

        // 分類コードから対象のオプション分類情報が格納されたオブジェクトを取得
        var tempOpbrObj = this.inputForm.listOpClass.find((item) =>{
          return item.opbr == in_opbr
        })

      	// 初期チェック'1':trueのものを探す
      	var tempOpcdObj = tempOpbrObj.listOpItems.find((item) =>{
            return item.dffg == '1'
          })

      	if(tempOpcdObj != null) {
      		resultOpcd = tempOpcdObj.opcd
      	}

      	return resultOpcd
      }
      // その他--------------------------------------------------E
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/SelectOption/CommonSelectOption.vue